import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'logisticsCompanies',
    collectionActionName: 'COMPANIES',
    itemActionName: 'COMPANY',
});
